import React from 'react';

import './LeftMenuWide.css';

const LeftMenuWide = () => {
	return (
		<nav id="leftmenuwide">
			<a href="/">Find Elyx</a>
			<a href="/">Buy Elyx</a>
			<a href="/">Absolut Elyx Boutique</a>
			<a href="/">Cocktails</a>
			<a href="/">Discover Elyx</a>
		</nav>
	);
};

export default LeftMenuWide;
